import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function PaiementMastercardIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<g clipPath="url(#clip0_7286_166579)">
				<path d="M0 4H24V20H0V4Z" fill="white" />
				<path d="M9.66854 16.7136H15.3262V7.28555H9.66854V16.7136Z" fill="#F06022" />
				<path
					d="M10.2533 12.0033C10.2507 11.0946 10.4516 10.1974 10.8406 9.38081C11.2297 8.56419 11.7965 7.84993 12.4974 7.29304C11.3674 6.38188 9.94987 5.92801 8.5145 6.01776C7.07914 6.10751 5.72604 6.73461 4.71257 7.77979C4.16977 8.33362 3.73906 8.99181 3.44517 9.71659C3.15129 10.4414 3 11.2185 3 12.0033C3 12.7881 3.15129 13.5652 3.44517 14.29C3.73906 15.0148 4.16977 15.673 4.71257 16.2268C5.72604 17.272 7.07914 17.8991 8.5145 17.9888C9.94987 18.0786 11.3674 17.6247 12.4974 16.7136C11.8002 16.1533 11.236 15.4383 10.8473 14.6225C10.4586 13.8066 10.2555 12.9111 10.2533 12.0033Z"
					fill="#EA1D25"
				/>
				<path
					d="M22 12.0033C22 13.5909 21.386 15.111 20.2895 16.2343C19.2683 17.2687 17.915 17.8876 16.4815 17.9758C15.048 18.0639 13.632 17.6154 12.4974 16.7136C13.1934 16.1521 13.7567 15.437 14.1453 14.6214C14.5338 13.8058 14.7376 12.9108 14.7415 12.0033C14.7425 11.0949 14.5408 10.1983 14.1519 9.38193C13.763 8.56557 13.197 7.85108 12.4974 7.29304C13.6271 6.37882 15.0456 5.92242 16.4826 6.0108C17.9197 6.09919 19.2747 6.72619 20.2895 7.7723C20.8338 8.32645 21.2652 8.98579 21.5589 9.71209C21.8525 10.4384 22.0024 11.2172 22 12.0033Z"
					fill="#F79D1D"
				/>
			</g>
			<defs>
				<clipPath id="clip0_7286_166579">
					<rect width="24" height="16" fill="white" transform="translate(0 4)" />
				</clipPath>
			</defs>
		</svg>
	);
}

PaiementMastercardIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default PaiementMastercardIcon;
